<template>
    <span>
        <a v-if="withLink" key="withLink" :href="formatURI" class="phone-number-display-link">{{ formatHuman }}</a>
        <span v-else key="noLink" class="phone-number-display">{{ formatHuman }}</span>
    </span>
</template>

<script>
import parsePhoneNumber from 'libphonenumber-js/min';

export default {
    name: 'PhoneNumberDisplay',
    components: {},
    props: {
        number: {  // phone number in E164 format, starting with '+', as a string
            type: String,
            required: true,
        },
        extension: {
            type: String,
            required: false,
        },
        national: {  // format as national style number (not international)
            type: Boolean,
            default: false,
        },
        withLink: {  // if true, then make this a URL with tel:+1408....
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {

        }
    },
    computed: {
        phoneNumberObject: function() {
            if (!this.number) return null;
            const phoneNumber = parsePhoneNumber(this.number);
            if (!phoneNumber.isValid()) return null;
            return phoneNumber;
        },
        formatInternational: function() {
            if (!this.phoneNumberObject) return '';
            return this.phoneNumberObject.formatInternational();
        },
        formatNational: function() {
            if (!this.phoneNumberObject) return '';
            return this.phoneNumberObject.formatNational();
        },
        formatURI: function() {
            if (!this.phoneNumberObject) return '';
            let phoneURI = this.phoneNumberObject.getURI();
            let extensionAddon = this.extension ? ',' + this.extension : '';
            return phoneURI + extensionAddon;
        },
        formatHuman: function() {
            let numberPart = this.national ? this.formatNational : this.formatInternational;
            let extensionPart = this.extension ? '  ext. ' + this.extension : '';
            return numberPart + extensionPart;
        }
    }
}
</script>

<style>

</style>